import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import PageContainer from "shared/components/pagecontainer/PageContainer";
import { buscarProdutoPorId } from "shared/services/api/produto.api";
import { IProduto } from "shared/interfaces/IProduto";
import { ProdutoModal } from "shared/components/modal/ProdutoModal";

export const Produto: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [produtoAtual, setProdutoAtual] = useState<IProduto | null>(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    let ativo = true;

    async function carregarProduto() {
      if (!id) {
        navigate(-1);
        return;
      }

      try {
        setCarregando(true);
        const produto = await buscarProdutoPorId(id);

        if (!ativo) return;

        if (!produto) {
          navigate(-1);
          return;
        }

        setProdutoAtual(produto);
      } catch (error) {
        if (ativo) {
          navigate(-1);
        }
      } finally {
        if (ativo) {
          setCarregando(false);
        }
      }
    }

    carregarProduto();

    return () => {
      ativo = false;
    };
  }, [id, navigate]);

  if (carregando) {
    return (
      <PageContainer title="Detalhes do Produto" showDesktopSearch={false}>
        <p>Carregando produto...</p>
      </PageContainer>
    );
  }

  if (!produtoAtual) {
    return null;
  }

  return (
    <PageContainer title="Detalhes do Produto" showDesktopSearch={false}>
      <ProdutoModal
        produto={produtoAtual}
      />
    </PageContainer>
  );
};
